import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { TenantDetailsFormDataTenant } from '@/common/viewModels/tenantDetails/form/data/TenantDetailsFormDataTenant';
import { TenantDetailsFormStateTenant } from '@/common/viewModels/tenantDetails/form/state/TenantDetailsFormStateTenant';
import { TenantDetailsApi, CloudOrganizationSummary } from '@/common/models';
import { AuthenticationMode, CloudOrganizationStatus, CloudCustomerType } from '@/common/viewModels/Enums';
import {TelstraUIVueDialog} from '@/external/telstra-ui-vue/components';
import TenantDetailsMicrosoftPartner from '@/components/tenantDetails/partner/TenantDetailsMicrosoftPartner.vue';
import { TenantDetailsFormDataMicrosoftPartner } from '@/common/viewModels/tenantDetails/form/data/TenantDetailsFormDataMicrosoftPartner';
import { TenantDetailsFormStateMicrosoftPartner } from '@/common/viewModels/tenantDetails/form/state/TenantDetailsFormStateMicrosoftPartner';
import { ItemViewModel } from '@/common/viewModels';

@Component({
  components: {
    TelstraUIVueDialog,
    TenantDetailsMicrosoftPartner,
  },
})
export default class TenantDetailsEditTenant extends Vue {
  @Prop({ required: true }) tenantDetails!: TenantDetailsApi;
  @Prop({ required: true }) cloudOrganization!: CloudOrganizationSummary;
  @Prop({ required: true }) salesChannels!: ItemViewModel[];
  @Prop({ required: true }) tenantPartners!: ItemViewModel[];
  @Prop({ required: true }) data!: TenantDetailsFormDataTenant;
  @Prop({ required: true }) state!: TenantDetailsFormStateTenant;
  @Prop({ required: true }) microsoftPartnerData!: TenantDetailsFormDataMicrosoftPartner;
  @Prop({ required: true }) microsoftPartnerState!: TenantDetailsFormStateMicrosoftPartner;
  @Prop({ required: true }) isLoading!: boolean;
  @Prop() testing!: boolean;

  get isCloudOrganizationIdMandatory(): boolean {
    return this.tenantDetails!.authenticationMode === AuthenticationMode.Azure;
  }

  get isAuthenticationDomainMandatory(): boolean {
    return (this.data!.cloudOrganizationId !== undefined && this.data!.cloudOrganizationId!.length > 0);
  }

  get shouldDisableAzurePlanOdinSubscriptionId(): boolean {
    return this.isLoading || !!this.tenantDetails.azurePlanOdinSubscriptionId;
  }

  get isStatusActive(): boolean {
    return this.tenantDetails.cloudOrganizationStatus === CloudOrganizationStatus.Created;
  }

  get isTenantInCsp(): boolean {
    return (((this.cloudOrganization.status === CloudOrganizationStatus.Pending) ||
      (this.cloudOrganization.status === CloudOrganizationStatus.Creating)) &&
      this.cloudOrganization.cloudCustomerType === CloudCustomerType.AzureCspNonTelstra);
  }

  get statusBadgeVariant(): string {
    return this.isStatusActive ? 'success outline' : 'warning outline';
  }

  get statusBadgeLabel(): string {
    return this.isStatusActive ? 'Active' : 'Progressing';
  }

  get showStatusActiveLink(): boolean {
    return this.isTenantInCsp;
  }

  get showStatus(): boolean {
    return !!this.tenantDetails.cloudOrganizationId && this.tenantDetails.cloudOrganizationId.length > 0 &&
      !!this.tenantDetails.authenticationDomain && this.tenantDetails.authenticationDomain.length > 0;
  }

  get isMpnIdEnabled(): boolean {
    return !this.$appConfig.featureFlags.disableMpnId;
  }

  mounted(): void {
    this._initialiseVForm();
  }

  statusActiveClick() {
    (this.$refs.statusActiveConfirmationModal as TelstraUIVueDialog).show();
  }

  hideStatusActiveConfirmationModal() {
    (this.$refs.statusActiveConfirmationModal as TelstraUIVueDialog).hide();
  }

  @Emit()
  onAddMicrosoftPartnerClick(): void {
    this.$emit('addMicrosoftPartnerClick');
  }

  @Emit()
  onEditMicrosoftPartnerClick(): void {
    this.$emit('editMicrosoftPartnerClick');
  }

  @Emit()
  onRemoveMicrosoftPartnerClick(): void {
    this.$emit('removeMicrosoftPartnerClick');
  }

  @Emit()
  onMicrosoftPartnerInput(mpnId: string) {
    this.$emit('microsoftPartnerInput', mpnId);
  }

  @Emit()
  statusActiveConfirmationModalConfirm(): void {
    this.$emit('statusActiveClick');
  }

  @Emit()
  formInputChange(inputEvent: any) {
    const target: any = inputEvent.target;
    this.$emit('formInputChange', target.name, target.value);
  }

  private _initialiseVForm() {
    if (this.testing !== true) {
      (this.$refs.vForm as any).validate();
    }
  }
}
